import { Node_Type } from 'ricos-schema';

export const INSERT_POLL_MODAL_ID = `${Node_Type.POLL}.insert`;
export const POLL_SETTINGS_MODAL_ID = `${Node_Type.POLL}.settings`;
export const POLL_SETTINGS_LAYOUT_MODAL_ID = `${Node_Type.POLL}.layout`;
export const POLL_SETTINGS_DESIGN_MODAL_ID = `${Node_Type.POLL}.design`;

export const SETTINGS_TAB = {
  layout: 'layout',
  design: 'design',
  settings: 'settings',
} as const;

export type SettingsType = (typeof SETTINGS_TAB)[keyof typeof SETTINGS_TAB];

export const POLL_BUTTONS = {
  layout: `${Node_Type.POLL}.layout`,
};
